export default __webpack_public_path__ + "static/media/logotype-maor-child.67ea0753.png";